/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type AreaOfStudyEntity, areaOfStudySchema } from '@axiom/domain';
import { AreaOfStudyCategory } from '../../../enums/generated/area-of-study-category';

/** UpdateAreaOfStudyRequest — dark-roast DTO: PatchAreaOfStudyResponseDto */
export const updateAreaOfStudyRequestSchema = areaOfStudySchema.pick({ "id": true, "name": true }).extend({ "category": z.nativeEnum(AreaOfStudyCategory).nullish(), "isStem": z.boolean() });
export type UpdateAreaOfStudyRequest = Pick<AreaOfStudyEntity, "id" | "name"> & z.infer<typeof updateAreaOfStudyRequestSchema>;
